import {
  EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE,
  EDITING_DOCUMENTS_LIST_FETCH_REQUEST,
  EDITING_DOCUMENTS_LIST_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';

type EditingDocumentsItemsState = string[];

const initialState: EditingDocumentsItemsState = [];

export default function reducer(
  state: EditingDocumentsItemsState = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE:
    case EDITING_DOCUMENTS_LIST_FETCH_REQUEST:
      return initialState;
    case EDITING_DOCUMENTS_LIST_FETCH_SUCCESS: {
      const { editingDocuments } = action.payload;
      return editingDocuments.map((editingDocument) => editingDocument.editingDocumentId);
    }
    default:
      return state;
  }
}
